/**
 * SAM-557 — which money action the booking panel offers. The booking flow authorizes with
 * `capture: false` (sam-lambda-functions functions/booking/booking_ops.py), so `paid` on a booking
 * means "authorized, not captured": there is nothing to refund yet, only an authorization to void.
 * Refund is offered only once the booking says money was captured. The server accepts void/refund
 * only from `paid` or `partially_refunded`, so any other status gets neither button.
 */
export function bookingPaymentActions(paymentStatus: string | null | undefined): { void: boolean; refund: boolean } {
  const status = (paymentStatus || '').toLowerCase();
  return { void: status === 'paid', refund: status === 'partially_refunded' };
}
